export default __webpack_public_path__ + "static/media/memoryPic.08406167.png";